/**
 * ルーター設定
 * React Routerのルート定義とナビゲーション設定
 */

import { createBrowserRouter, Navigate } from 'react-router-dom'
import { RootLayout } from '../layout/RootLayout'
import ErrorPage from '@/pages/ErrorPage'
import DashboardPage from '@/pages/HomePage'
import LoginPage from '@/pages/LoginPage'
import MastersPage from '@/features/masters/pages/MastersPage'
import CompanyVehiclesPage from '@/features/masters/pages/CompanyVehiclesPage'
import CraftsmenPage from '@/features/masters/pages/CraftsmenPage'
import TruckDriversPage from '@/features/masters/pages/TruckDriversPage'
import TrucksPage from '@/features/masters/pages/TrucksPage'
import NotFoundPage from '@/pages/NotFoundPage'
import ProjectDetailPage from '@/features/projects/pages/[project_id]/page'
import ProjectsPage from '@/features/projects/pages/ProjectsPage'
import UsersPage from '@/features/users/pages/UsersPage'
import { AuthGuard } from './AuthGuard'

/**
 * アプリケーションのルーター設定
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorPage error={new Error('Page not found')} reset={() => window.location.reload()} />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />
      },
      {
        path: 'dashboard',
        element: <AuthGuard><DashboardPage /></AuthGuard>
      },
      {
        path: 'projects',
        children: [
          {
            index: true,
            element: <AuthGuard><ProjectsPage /></AuthGuard>
          },
          {
            path: ':project_id',
            element: <AuthGuard><ProjectDetailPage /></AuthGuard>
          }
        ]
      },
      {
        path: 'project-detail',
        element: <AuthGuard><ProjectDetailPage /></AuthGuard>
      },
      {
        path: 'masters',
        children: [
          {
            index: true,
            element: <AuthGuard><MastersPage /></AuthGuard>
          },
          {
            path: 'company-vehicles',
            element: <AuthGuard><CompanyVehiclesPage /></AuthGuard>
          },
          {
            path: 'craftsmen',
            element: <AuthGuard><CraftsmenPage /></AuthGuard>
          },
          {
            path: 'truck-drivers',
            element: <AuthGuard><TruckDriversPage /></AuthGuard>
          },
          {
            path: 'trucks',
            element: <AuthGuard><TrucksPage /></AuthGuard>
          }
        ]
      },
      {
        path: 'users',
        element: <AuthGuard><UsersPage /></AuthGuard>
      },
      {
        path: '*',
        element: <NotFoundPage />
      }
    ]
  }
])